class RepresentMarquee extends HTMLElement {

  constructor() {
    super();
    this._initialized = false;
    this._speedUnits = 1;
    this._handleRecomputeDuration = this._recomputeDuration.bind(this);
  }

  connectedCallback() {
    if (this.hasAttribute('disabled')) return;
    if (this._initialized) return;
    this._initialized = true;

    this._parseConfig();
    this._handleRecomputeDuration();
    this._injectStyleTag();
    this._observeSizeChanges();
  }

  disconnectedCallback() {
    this._teardownObservers();
    if (this._rafId) cancelAnimationFrame(this._rafId);
  }

  _parseConfig() {
    this._speedUnits = this._parseSpeed(this.getAttribute('speed'));
    this._pauseOnHover = this.hasAttribute('pause-on-hover');
    this._first = this.querySelector('.rep-marquee__content');
  }

  _parseSpeed(value) {
    const n = parseFloat(value);
    return Number.isFinite(n) && n > 0 ? n : 1;
  }


  _injectStyleTag() {
    if (document.getElementById('represent-marquee-animation-init')) {
      return;
    }

    const styleEl = document.createElement('style');
    styleEl.id = 'represent-marquee-animation-init';
    styleEl.textContent = `
      represent-marquee .rep-marquee__content {
        animation: rep-marquee-scroll var(--rep-marquee-duration) linear infinite;
      }
    `;
    document.head.appendChild(styleEl);
  }

  _recomputeDuration() {
    const width = this._first.getBoundingClientRect().width;
    const computed = getComputedStyle(this._first);
    const gap = parseFloat(computed.gap) || parseFloat(computed.columnGap) || 0;
    const distancePx = width + gap;
    const pps = Math.max(1, this._speedUnits * 100); // pixels per second
    const seconds = distancePx / pps;
    this.style.setProperty('--rep-marquee-duration', `${seconds}s`);
  };

  _observeSizeChanges() {
    if (typeof ResizeObserver !== 'undefined') {
      this._ro = new ResizeObserver(() => {
        cancelAnimationFrame(this._rafId);
        this._rafId = requestAnimationFrame(this._handleRecomputeDuration);
      });
      this._ro.observe(this._first);
      return;
    }

    this._onResize = () => {
      cancelAnimationFrame(this._rafId);
      this._rafId = requestAnimationFrame(this._handleRecomputeDuration);
    };
    window.addEventListener('resize', this._onResize);
  }

  _teardownObservers() {
    if (this._ro) this._ro.disconnect();
    if (this._onResize) window.removeEventListener('resize', this._onResize);
  }
}

customElements.define('represent-marquee', RepresentMarquee);
